import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import SvgIcon from '@material-ui/core/SvgIcon'

import Markdown from './Markdown'

import { Heading4 } from '../styleguide'

const styles = {
  panelRootStyle: {
    padding: '16px 0 16px 6px',
    borderTop: '1px solid #d6d8db',
    backgroundColor: '#fafafa',
    '&:before': {
      display: 'none'
    },
    '&:last-child': {
      borderBottom: '1px solid #d6d8db'
    }
  },
  summaryRootStyle: {
    minHeight: 'inherit !important',
    padding: 0
  },
  noMargin: {
    margin: 0
  },
  detailsStyle: {
    padding: 0,
    marginTop: 16
  },
  expandIconStyle: {
    marginRight: 10,
    right: 0,
    width: 'auto',
    height: 'auto',
    '@media print': {
      display: 'none !important'
    }
  },
  ArrowDropDownIconStyle: {
    width: 16,
    height: 16,
    color: '#838A92'
  }
}

const ArrowDropDownIcon = withStyles(styles)(
  ({ viewBox = '0 0 16 16', classes, ...rest }) => (
    <SvgIcon
      viewBox={viewBox}
      classes={{ root: classes.ArrowDropDownIconStyle }}
      {...rest}
    >
      <g>
        <polygon fill="currentColor" points="4 6 8 10 12 6" />
      </g>
    </SvgIcon>
  )
)

class Accordion extends Component {
  state = {
    activePanel: this.props.activePanel
  }

  componentWillReceiveProps({ activePanel }) {
    this.setState({ activePanel })
  }

  Panel = ({
    headline,
    description,
    active,
    onActivePanelChange,
    panelStyle,
    panelSummaryStyle,
    panelDetailsStyle
  }) => (
    <ExpansionPanel
      elevation={0}
      classes={panelStyle}
      className="accordion-panel"
      expanded={active}
      onChange={(_, expanded) => onActivePanelChange(expanded ? headline : '')}
    >
      <ExpansionPanelSummary
        expandIcon={<ArrowDropDownIcon />}
        classes={panelSummaryStyle}
      >
        <Heading4>{headline}</Heading4>
      </ExpansionPanelSummary>

      <ExpansionPanelDetails classes={panelDetailsStyle}>
        <Markdown source={description} />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )

  render() {
    const {
      panels,
      onActivePanelChange,
      classes: {
        panelRootStyle,
        summaryRootStyle,
        noMargin,
        detailsStyle,
        expandIconStyle
      }
    } = this.props
    const panelClasses = {
      panelStyle: { root: panelRootStyle, expanded: noMargin },
      panelSummaryStyle: {
        root: summaryRootStyle,
        content: noMargin,
        expandIcon: expandIconStyle
      },
      panelDetailsStyle: { root: detailsStyle }
    }
    const { activePanel } = this.state
    const Panel = this.Panel

    return (
      <div>
        {panels.map(panel => (
          <Panel
            key={panel.headline}
            active={activePanel === panel.headline}
            onActivePanelChange={onActivePanelChange}
            {...panel}
            {...panelClasses}
          />
        ))}
      </div>
    )
  }
}

export default withStyles(styles)(Accordion)



// WEBPACK FOOTER //
// ./src/components/Accordion.js